// Gradient fade line between sections
// A single 3px horizontal line that's transparent on both ends and peaks at ~8% white opacity in the center

export default function GradientFadeLine({ className = '' }) {
  return (
    <div 
      className={`w-full ${className}`}
      style={{
        height: '3px',
        background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.08) 50%, transparent 100%)',
      }}
    />
  );
}
